// extracted by mini-css-extract-plugin
module.exports = {"call-float":"SideCall_call-float__h7ZBt","sidebaricon":"SideCall_sidebaricon__k6jKq","hithere":"SideCall_hithere__1GIjp"};